import React from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import './selectDropdown.css';

interface Option {
  value: string | number;
  label: string;
  data?: Record<string, unknown>;
}

interface SelectDropdownProps {
  options: Option[];
  value?: string | number;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string | number, data?: Record<string, unknown>) => void;
  className?: string;
  label?: string;
  isMobile?: boolean;
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
  options,
  value,
  placeholder = 'Seleccione',
  disabled = false,
  onChange,
  className = '',
  label,
  isMobile = false,
}) => {
  const selectedOption = options.find((option) => option.value.toString() === value?.toString());
  const displayText = selectedOption ? selectedOption.label : placeholder;

  const handleSelectDesktop = (eventKey: { value: string | number; data?: Record<string, unknown> }) => {
    if (eventKey && eventKey.value !== undefined) {
      onChange(eventKey.value, eventKey.data);
    }
  };

  const handleSelectMobile = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = event.target.value;
    const selectedOption = options.find((opt) => opt.value.toString() === selectedValue);
    if (selectedOption) {
      onChange(selectedOption.value, selectedOption.data);
    }
  };

  const renderDesktopDropdown = () => (
    <DropdownButton
      dropup={false}
      className={`dropdown-custom ${className}`}
      bsStyle="inline"
      onSelect={handleSelectDesktop}
      title={displayText}
      id="dropdown-select"
      disabled={disabled}
    >
      {options.map((option, index) => (
        <MenuItem
          key={index}
          eventKey={{
            value: option.value,
            data: option.data,
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </DropdownButton>
  );

  const renderMobileSelect = () => (
    <select
      className={`select-custom form-input ${className}`}
      onChange={handleSelectMobile}
      value={value || ''}
      disabled={disabled}
    >
      <option value="">{placeholder}</option>
      {options.map((option, index) => (
        <option key={index} value={option.value} data-label={option.label}>
          {option.label}
        </option>
      ))}
    </select>
  );

  return (
    <div className="select-dropdown-container">
      {label && (
        <div className="select-label">
          <p>
            {label}:<span className="required-asterisk">*</span>
          </p>
        </div>
      )}
      <div className="select-input-container">
        {window.innerWidth >= 770 && !isMobile ? renderDesktopDropdown() : renderMobileSelect()}
      </div>
    </div>
  );
};

export default SelectDropdown;
